import { combineReducers, createStore, applyMiddleware } from 'redux';
import UserAuthentication from './reducers/userAuth';
import HeaderReducer from './reducers/headerReducer';
import createSagaMiddleware from 'redux-saga'
import MainSaga from './redux-saga/mainSaga';


const sagaMiddleware = createSagaMiddleware()

const appReducer = combineReducers({
    UserAuthentication,HeaderReducer
});

let store = createStore(appReducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(MainSaga);

export default store;


// WEBPACK FOOTER //
// ./src/redux/configureStore.js